// HydrationContext.js
import React, { createContext, useContext, useState } from 'react';

const HydrationContext = createContext({
  hydratedFor: null,
  setHydratedFor: () => {},
});

export function HydrationProvider({ children }) {
  const [hydratedFor, setHydratedFor] = useState(null);
  return (
    <HydrationContext.Provider value={{ hydratedFor, setHydratedFor }}>
      {children}
    </HydrationContext.Provider>
  );
}

export const useHydration = () => useContext(HydrationContext);
